import React, { useEffect, useState } from "react"
import getHttpsCallable from "../utils/getHttpsCallable"
import { setZendeskTokens } from "../lib/utils/zendeskToken"

const zendeskAuth = getHttpsCallable("admin-zendeskAuth")

export default function ZendeskOauth () {

  useEffect(() => {
    const url = window.location.href
    let code:string = ""
    if (url.indexOf("code=") !== -1) {
      const params = new URLSearchParams(window.location.search)
      code = params.get("code") ?? ""
    }
    const verifier = localStorage.getItem("zendesk_code_verifier")

    if (!code || !verifier) {
      console.error("Missing authorization code or verifier.")
      return
    }

    async function exchangeToken () {
      try {
        const response = await zendeskAuth({
          code,
          verifier,
          redirect_uri: `${window.origin}/zendesk_oauth`,
        })

        setZendeskTokens({
          accessToken: response.data.accessToken,
          refreshToken: response.data.refreshToken,
          expiresIn: response.data.expiresIn,
          refreshTokenExpiresIn: response.data.refreshTokenExpiresIn,
        })
        localStorage.removeItem("zendesk_code_verifier")
        const redirectUrl = localStorage.getItem("zendesk_oauth_complete_url")
        if (redirectUrl?.startsWith(window.location.origin)) {
          window.location.replace(redirectUrl)
        }

      }
      catch (err) {
        console.error("Token exchange failed.", err)
      }
    }

    exchangeToken()
  }, [])

  return (
    <div />
  )
}
